module.exports = __webpack_public_path__ + "media/src/images/icons/menu/button-77c3d610831d7cf72d92983d12dedbc9.svg";